// Hex mirrors of the CSS theme tokens in src/index.css, for places that can't
// use Tailwind classes (charts, canvas, SVG strokes, spinner props).
export const THEME = {
  canvas: "#040504",
  surface: "#0b0d0b",
  elevated: "#121512",
  line: "#222823",
  fg: "#e6efe8",
  fgMuted: "#8e9c92",
  primary: "#39ff88",
  accent: "#ff8a1f",
  danger: "#ff5454",
};

// Six-step pronunciation accuracy scale: red → orange → green.
const ACCURACY_SCALE = [
  "#ff5454",
  "#ff6f3a",
  "#ff8a1f",
  "#ffb020",
  "#a6ff5c",
  "#39ff88",
];

export function accuracyToColor(accuracy) {
  if (accuracy < 17) return ACCURACY_SCALE[0];
  if (accuracy < 34) return ACCURACY_SCALE[1];
  if (accuracy < 51) return ACCURACY_SCALE[2];
  if (accuracy < 68) return ACCURACY_SCALE[3];
  if (accuracy < 85) return ACCURACY_SCALE[4];
  return ACCURACY_SCALE[5];
}
